var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M367.304,25.402C333.648,9.128,295.89,0,256,0s-77.648,9.128-111.304,25.402L122.435,256 l22.261,230.598C178.352,502.872,216.11,512,256,512s77.648-9.128,111.304-25.402L389.565,256L367.304,25.402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M144.696,25.411C59.066,66.818,0,154.507,0,256s59.066,189.182,144.696,230.589V25.411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M367.304,25.411v461.178C452.934,445.182,512,357.493,512,256S452.934,66.818,367.304,25.411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9811"
    },
    d: "M345.043,201.419h-61.217c0-15.368-12.458-27.826-27.826-27.826s-27.826,12.458-27.826,27.826 h-61.217c0,15.131,13.181,27.396,28.31,27.396h-0.912c0,15.132,12.266,27.399,27.398,27.399c0,13.397,9.622,24.529,22.33,26.909 l-21.59,48.742c10.345,4.205,21.651,6.542,33.507,6.542c11.855,0,23.162-2.337,33.506-6.542l-21.589-48.742 c12.708-2.38,22.33-13.512,22.33-26.909c15.132,0,27.398-12.267,27.398-27.399h-0.913 C331.863,228.815,345.043,216.549,345.043,201.419z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "256,239.304 219.826,256 219.826,289.391 256,311.652 292.174,289.391 292.174,256 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.826,
    y: 222.609,
    style: {
      fill: "#D80027"
    },
    width: 72.348,
    height: 33.391
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMd);
export default __webpack_public_path__ + "static/media/md.5805ef5b08977b1fc210336d4d8374a1.svg";
export { ForwardRef as ReactComponent };